jQuery( function ( $ ) {
  $('a[href^="#"]').on('click', function(event) {
    event.preventDefault();
    const target = $(this.getAttribute('href'));
    if (target.length) {
        $('html, body').stop().animate({
            scrollTop: target.offset().top  // ここを修正
        }, 800);  // アニメーションの所要時間（ミリ秒）も設定可能
    }
  });
});
